import React from 'react';

// Import necessary components
import { PageTitle, SellCar } from '../../../components';



const SellCarPage = () => { 
  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Sell Your Car'} page={'Sell Your Car'} />

      {/* Quote Form Section */}
      <SellCar />
    </>
  );
}

export default SellCarPage;